<app-i18n-dictionary>
    <span [attr.transid]="emailPlaceholderTextId" i18n="@@email-placeholder">Email</span>
</app-i18n-dictionary>

<form fxLayout="column" [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field>
        <input appIosAutoFillFix type="email" matInput
               [placeholder]="i18nDictionary.get(emailPlaceholderTextId)"
               formControlName="email" required/>
        <mat-error *ngIf="emailControl.hasError('required')"
                   i18n="@@email-error-required">You must enter a value
        </mat-error>
        <mat-error *ngIf="emailControl.hasError('email')"
                   i18n="@@email-error-email">Not a valid email
        </mat-error>
    </mat-form-field>

    <ng-hcaptcha formControlName="captcha" [languageCode]="currentLang"></ng-hcaptcha>
    <mat-error *ngIf="captchaControl.hasError('required') && captchaControl.touched"
               i18n="@@captcha-error-required">You must complete the CAPTCHA
    </mat-error>

    <div class="actions" fxLayout="row" fxLayoutAlign="center center">
        <button class="btn-primary" [disabled]="isPending" i18n="@@password-reset-form_submit-button">
            Submit
        </button>
        <mat-spinner [diameter]="25" *ngIf="isPending"></mat-spinner>
    </div>
</form>

<div class="actions" fxLayout="row" fxLayoutAlign="center center">
    <button class="btn-primary" [disabled]="isPending" i18n="@@password-reset-form_back-button"
            (click)="goBack()">Return to login
    </button>
</div>


<p *ngIf="resetSuccessful" class="resetSuccessful"
   i18n="@@password-reset-form_request-reset_successful">
    Password reset successful! Please check your emails.
</p>

<p *ngIf="resetError && !resetError.isGlobalMessage" class="resetError">
    {{ resetError.errorMessage }} [{{ resetError.errorCodeFormatted }}]
</p>

<app-contact-box></app-contact-box>
